import script from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=166dfda0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166dfda0"]])

export default __exports__